// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1hnys","boxTitle":"Qualiphy_boxTitle__2mOpa","box":"Qualiphy_box__XaOpF","toggleWrap":"Qualiphy_toggleWrap__2UV9d"};